import React, { useCallback, useState } from 'react'
import { Modal, gaEvent } from 'shared'

import teaserImage from './create_fundraising_event_modal.svg'
import { CreateFundraisingEventButtonProps, CreateFundraisingEventButtonModalContentProps } from './types'

import heartFundraisingEventIcon from './icon-heart-fundraising.svg'
export const AbCreateFundraisingEventButton = (props: CreateFundraisingEventButtonProps) => {
  const [show, setShow] = useState(false)

  const handleClick = useCallback(() => {
    gaEvent('engagement', 'click fe_modal_open_link')
    setShow(true)
  }, [])

  const onHide = useCallback(() => {
    gaEvent('engagement', 'click fe_modal_close_link')
    setShow(false)
  }, [])

  return (
    <div className="mb-4 mt-6">
      <div className="flex items-start">
        <img src={heartFundraisingEventIcon} alt="" />
        <div className="flex flex-col ml-4">
          <p>
            {I18n.locale === 'de'
              ? 'Sammle gemeinsam mit Bekannten selbst Spenden für dieses Projekt'
              : 'Collect donations for this project together with your community'}
          </p>
          <a onClick={handleClick}>{I18n.locale === 'de' ? 'Mehr erfahren' : 'Learn more'}</a>
        </div>
      </div>

      <Modal
        show={show}
        onHide={onHide}
        content={<ModalContent {...props} />}
        header={I18n.t('projects.show.stats.create_fundraising_event_modal_headline')}
        size="modal-lg"
      />
    </div>
  )
}

const ModalContent = ({ readmoreUrl, ctaUrl }: CreateFundraisingEventButtonModalContentProps): JSX.Element => (
  <div>
    <img src={teaserImage} width="100%" className="mb-3" />

    <span>{I18n.t('projects.show.stats.create_fundraising_event_modal_explanation')}</span>

    <div className="text-center mt-4">
      <a
        className="btn btn-primary btn-large"
        href={ctaUrl}
        target="_blank"
        onClick={() => gaEvent('navigation', 'click fe_modal__create_button')}
        rel="noreferrer"
      >
        {I18n.t('projects.show.stats.create_fundraising_event_modal_cta')}
      </a>
    </div>

    <div className="text-center mt-3">
      <a
        href={readmoreUrl}
        target="_blank"
        onClick={() => gaEvent('navigation', 'click fe_modal__read_more_link')}
        rel="noreferrer"
      >
        {I18n.t('projects.show.stats.create_fundraising_event_modal_readmore')}
      </a>
    </div>
  </div>
)
